/**
 * Buybox prices for a saved wizard journey.
 * Bag count picks a weight band on that wizard's full-food product.
 * A saved plan anchors the band: the plan's bag count keeps that household's price.
 */
(function (root) {
  var JOURNEY_KEY = 'bz_journey_id';
  var PLAN_KEY = 'bz_buybox_plan';
  var FLAVORS = ['rund', 'kip', 'vis'];

  function storageGet(store, key) {
    try {
      return store.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function storageSet(store, key, value) {
    try {
      store.setItem(key, value);
    } catch (e) {}
  }

  function readJourneyId() {
    var local = root.localStorage ? storageGet(root.localStorage, JOURNEY_KEY) : '';
    var session = root.sessionStorage ? storageGet(root.sessionStorage, JOURNEY_KEY) : '';
    var id = local || session;
    return id === 'w3' || id === 'w4' || id === 'w5' ? id : '';
  }

  function rememberJourney(id) {
    if (id !== 'w3' && id !== 'w4' && id !== 'w5') return;
    if (root.sessionStorage) storageSet(root.sessionStorage, JOURNEY_KEY, id);
    if (root.localStorage) storageSet(root.localStorage, JOURNEY_KEY, id);
  }

  function readPlan() {
    if (!root.localStorage) return null;
    try {
      var plan = JSON.parse(storageGet(root.localStorage, PLAN_KEY) || 'null');
      if (!plan || (plan.journeyId !== 'w3' && plan.journeyId !== 'w4' && plan.journeyId !== 'w5')) return null;
      if (!Number(plan.bags) || !Number(plan.kg)) return null;
      return plan;
    } catch (e) {
      return null;
    }
  }

  function writePlan(plan) {
    if (!root.localStorage) return;
    if (!plan) {
      try { root.localStorage.removeItem(PLAN_KEY); } catch (e) {}
      return;
    }
    storageSet(root.localStorage, PLAN_KEY, JSON.stringify(plan));
  }

  function sortedBands(entry) {
    return ((entry && entry.bands) || []).slice().sort(function (a, b) {
      return a.min_kg - b.min_kg;
    });
  }

  function clamp(index, length) {
    if (length <= 0) return 0;
    return Math.max(0, Math.min(length - 1, index));
  }

  function bandIndexForKg(entry, kg) {
    var bands = sortedBands(entry);
    var weight = Math.min(100, Math.max(1, Math.round(Number(kg) || 1)));
    var found = bands.findIndex(function (band) {
      return weight >= band.min_kg && weight <= band.max_kg;
    });
    return found >= 0 ? found : Math.max(0, bands.length - 1);
  }

  /**
   * No plan: 1 bag is the most expensive band, each extra bag steps cheaper.
   * Saved plan: that bag count stays on the household band.
   */
  function bandIndexForBags(entry, bags, anchor) {
    var bands = sortedBands(entry);
    var count = Math.max(1, Math.round(Number(bags) || 1));
    if (!anchor || !Number(anchor.bags) || !Number(anchor.kg)) {
      return clamp(count - 1, bands.length);
    }
    var start = bandIndexForKg(entry, anchor.kg);
    return clamp(start + (count - Math.round(Number(anchor.bags))), bands.length);
  }

  function bandAt(entry, index) {
    var bands = sortedBands(entry);
    if (!bands.length) return null;
    var band = bands[clamp(index, bands.length)];
    var key = band.min_kg + '-' + band.max_kg;
    var variants = (entry.variants && entry.variants[key]) || {};
    return {
      index: clamp(index, bands.length),
      min_kg: band.min_kg,
      max_kg: band.max_kg,
      shopify_eur: band.shopify_eur,
      variants: {
        rund: variants.rund || '',
        kip: variants.kip || '',
        vis: variants.vis || ''
      }
    };
  }

  function bandForBags(entry, bags, anchor) {
    return bandAt(entry, bandIndexForBags(entry, bags, anchor));
  }

  function variantIds(entry) {
    var ids = [];
    var seen = {};
    sortedBands(entry).forEach(function (band) {
      var slot = entry.variants && entry.variants[band.min_kg + '-' + band.max_kg];
      FLAVORS.forEach(function (flavor) {
        var id = slot && slot[flavor];
        if (id && !seen[id]) {
          seen[id] = true;
          ids.push(String(id));
        }
      });
    });
    return ids;
  }

  var BEEF_WAIVER_SHOP_EUR = 2.22;

  /**
   * Shop-currency waiver converted into the currency of a fetched variant price.
   * presentmentList / shopListEur is the market rate already applied by Shopify.
   */
  function beefWaiverPresentment(shopListEur, presentmentList) {
    var shop = Number(shopListEur);
    var present = Number(presentmentList);
    if (!shop || !present) return 0;
    return BEEF_WAIVER_SHOP_EUR * (present / shop);
  }

  function flavorSelection(plan) {
    var flavors = {};
    FLAVORS.forEach(function (flavor) {
      var qty = Math.max(0, Math.round(Number(plan && plan.flavors && plan.flavors[flavor]) || 0));
      flavors[flavor] = { quantity: qty, selected: qty > 0 };
    });
    return flavors;
  }

  var api = {
    JOURNEY_KEY: JOURNEY_KEY,
    PLAN_KEY: PLAN_KEY,
    readJourneyId: readJourneyId,
    rememberJourney: rememberJourney,
    readPlan: readPlan,
    writePlan: writePlan,
    sortedBands: sortedBands,
    bandIndexForKg: bandIndexForKg,
    bandIndexForBags: bandIndexForBags,
    bandAt: bandAt,
    bandForBags: bandForBags,
    variantIds: variantIds,
    flavorSelection: flavorSelection,
    BEEF_WAIVER_SHOP_EUR: BEEF_WAIVER_SHOP_EUR,
    beefWaiverPresentment: beefWaiverPresentment
  };

  root.Buybox2Journey = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
